<template>
    <!--告警事件列表窗口-->
    <el-dialog
      class="alarm-events-modal"
      title="告警事件"
      :visible="modalOpen"
      :append-to-body="true"
      top="60px"
      width="80%"
      :before-close="handleModalCancel"
    >
    <div class="container-with-collapsible-tree-sidebar">
      <!--侧边栏-->
      <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="false" @toggle="toggleTreeSideBar">
        <div class="general-container">
          <el-input class="search-input"
                    v-model="treeNodeFilter"
                    placeholder="请输入区域名称"
                    clearable>
            <img slot="prefix" src="@/assets/img/icon_search.png">
          </el-input>
        </div>
        <el-tree
          class="mt5"
          ref="tree"
          :data="treeData"
          :props="defaultTreeProps"
          :default-expanded-keys="treeExpandedKeys"
          :expand-on-click-node="false"
          node-key="key"
          highlight-current
          style="max-height: 610px;overflow-y: auto"
          :filter-node-method="filterTreeNode"
          @node-click="handleTreeNodeClick"
        >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
        </el-tree>
      </app-tree-side>
      <!--表格数据-->
      <div class="col-2">
        <!--等信息内容-->
        <div class="general-container">
          <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="事件记录" name="0">
              <el-form ref="eventQueryForm" class="pagination-eventTable-query-form" :inline="true"
                       @keyup.enter.native="handleEventFormQuery()">
                <el-form-item label="告警状态" class="right-vertical-line pr15">
                  <el-checkbox-group v-model="eventTableQueryParams.alarmStates">
                    <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">
                      {{alarmState.name}}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="确认状态" class="right-vertical-line pr15">
                  <el-checkbox-group v-model="eventTableQueryParams.handleStates">
                    <el-checkbox v-for="handleState in $type.handleStates" :key="handleState.id" :label="handleState.id">
                      {{handleState.name}}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="事件触发时间">
                  <uni-date-range-picker
                    v-model="eventDates"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :append-to-body="false">
                  </uni-date-range-picker>
                </el-form-item>
                <el-form-item>
                  <el-button @click="handleEventFormQuery()" type="primary">查 询</el-button>
                  <el-button @click="resetEventQueryForm()">重 置</el-button>
                </el-form-item>
              </el-form>
              <div class="pagination-table-button-container">
                <el-button type="primary" @click="handleEventHandle()" :disabled="!eventTableSelectedIds.length">批量确认</el-button>
              </div>
              <div class="pagination-table-container">
                <el-table :data="eventTableData"
                          ref="eventTable"
                          v-loading="loading"
                          border highlight-current-row
                          element-loading-background="rgba(255, 255, 255, 0.8)"
                          element-loading-spinner="el-icon-loading"
                          element-loading-text="努力加载中..."
                          style="width: 100%; min-height: 450px;max-height: 450px;overflow-y: auto"
                          @selection-change="handleTableSelectionChange"
                          @current-change="handleTableCurrentChange">
                  <el-table-column type="selection" width="40"></el-table-column>
                  <el-table-column label="序号" type="index" width="60"></el-table-column>
                  <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                    <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
                  </el-table-column>
                  <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column label="告警状态" prop="alarmState" width="90">
                    <template slot-scope="scope">
                      <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                        {{scope.row.alarmStateText}}
                      </el-tag>
                    </template>
                  </el-table-column>
<!--                  <el-table-column label="告警级别" prop="alarmLevel" width="100">-->
<!--                    <template slot-scope="scope">{{ getNameById(scope.row.alarmLevel, $type.alarmLevels) }}</template>-->
<!--                  </el-table-column>-->
                  <el-table-column label="数值" prop="workStateText" width="90"></el-table-column>
                  <el-table-column label="事件类型" prop="eventTypeText" width="100"></el-table-column>
                  <el-table-column label="事件子类型" prop="eventSubTypeText" width="100"></el-table-column>
                  <el-table-column label="事件触发时间" prop="happenTime" width="160">
                    <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
                  </el-table-column>
                  <el-table-column label="正常区间" prop="alarmRuleText" width="80"></el-table-column>
                  <el-table-column label="确认状态" prop="handled" width="80">
                    <template slot-scope="scope">
                      <el-tag :type="(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1) ? 'primary':'warning'">
                        {{(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1) ? '--' : getNameById(scope.row.handled, $type.handleStates)}}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="130">
                    <template slot-scope="scope">
                      <el-button
                        class="col-btn"
                        type="text"
                        icon="el-icon-view"
                        @click="handleEventView(scope.row)"
                      >查看
                      </el-button>
                      <el-button
                        class="col-btn"
                        type="text"
                        icon="el-icon-s-check"
                        :disabled="scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1"
                        @click="handleEventHandle(scope.row)"
                      >确认
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination v-show="eventTableTotalRow > eventTableQueryParams.pageSize"
                               background
                               @current-change="handleEventCurrentPageChange"
                               @size-change="handleEventPageSizeChange"
                               :current-page.sync="eventTableQueryParams.pageNum"
                               :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                               :page-size.sync="eventTableQueryParams.pageSize"
                               prev-text="上一页"
                               next-text="下一页"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="eventTableTotalRow">
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!--显示告警事件信息-->
    <show-alarm-event v-if="showEventModalOpen" :modalOpen="showEventModalOpen" :alarmEvent="eventTableCurrentRow" @submit="handleShowEventModalSubmit" @cancel="handleShowEventModalCancel"></show-alarm-event>

    <!--确认告警事件弹窗-->
    <handle-alarm-event-Modal v-if="handelAlarmEventModalOpen" :modalOpen="handelAlarmEventModalOpen" :alarmEvent="eventTableCurrentRow" @submit="handleHandleAlarmEventModalSubmit" @cancel="handleHandleAlarmEventModalCancel"></handle-alarm-event-Modal>

    </el-dialog>
</template>

<script type="text/ecmascript-6">
import AlarmEventsModal from './AlarmEventsModal.js'

export default AlarmEventsModal
</script>

<style lang="scss">
  @import "AlarmEventsModal.scss";
</style>



// WEBPACK FOOTER //
// src/views/common/alarmEventsModal/AlarmEventsModal.vue